export const companyInfo = {
    name: 'Himolan Peak Adventures',
    contactPerson: 'Zahid Hassan',
    phoneDisplay: '0347 9020168',
    phoneDial: '03479020168',
    email: 'himolanpeakadventures@gmail.com',
    addressShort: 'College Road, Skardu',
    addressFull: 'College Road, Skardu',
    mapEmbedUrl: 'https://maps.google.com/maps?q=College%20Road%2C%20Skardu&t=&z=14&ie=UTF8&iwloc=&output=embed'
};

export const socialLinks = {
    facebook: 'https://www.facebook.com/share/1GFq93LN18/',
    instagram: 'https://www.instagram.com/hodophiletreks?igsh=OGVyNXE2OTN4MW1s',
    tiktok: 'https://www.tiktok.com/@himolanpeakadventure',
    whatsapp: `https://wa.me/03479020168`,
};

export const contactTourOptions = [
    { value: 'select-tour-type', label: 'Select Tour Type' },
    { value: 'skardu-blossom-by-road', label: 'Skardu Blossom Tour (By Road)' },
    { value: 'skardu-tour-by-air', label: 'Skardu Tour (By Air)' },
    { value: 'hunza-cherry-blossom', label: 'Hunza Cherry Blossom Tour' },
    { value: 'hunza-nagar-naltar-by-road', label: 'Hunza, Nagar & Naltar (By Road)' },
    { value: 'fairy-meadows-hunza', label: 'Fairy Meadows & Hunza Tour' }
];

export const buildWhatsAppInquiryUrl = (message) => {
    return `https://wa.me/${companyInfo.phoneDial}?text=${encodeURIComponent(message)}`;
};

export const buildWhatsAppInquiryMessage = ({ intro, fields = [], source = 'Website' }) => {
    const now = new Date();
    const inquiryId = `HPA-${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}-${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
    const submittedAt = now.toLocaleString('en-PK', { hour12: true });

    const lines = [intro || `Assalam o Alaikum, I want to contact ${companyInfo.name}.`];

    fields.forEach(([label, value]) => {
        lines.push(`${label}: ${value || 'N/A'}`);
    });

    lines.push(`Inquiry ID: ${inquiryId}`);
    lines.push(`Submitted At: ${submittedAt}`);
    lines.push(`Source: ${source}`);

    return lines.join('\n');
};

export const tourRecentPosts = {
    "skardu-blossom-tour": [
        {
            title: 'How to Plan a Northern Pakistan Tour',
            date: '12/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Travel Checklist for Blossom Season',
            date: '19/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        },
        {
            title: 'Skardu Valley: A Photographer\'s Paradise',
            date: '18/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        }
    ],
    "skardu-tour-by-air": [
        {
            title: 'Flying to Skardu: Everything You Need to Know',
            date: '17/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Skardu in Spring: Blossom Season Guide',
            date: '15/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        },
        {
            title: 'Best Time to Visit Skardu by Air',
            date: '14/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        }
    ],
    "skardu-honeymoon-special": [
        {
            title: 'Romantic Getaways in Northern Pakistan',
            date: '16/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Honeymoon Destinations: Skardu vs Other Spots',
            date: '13/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        },
        {
            title: 'Planning the Perfect Couple\'s Adventure',
            date: '11/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        }
    ],
    "hunza-cherry-blossom-tour": [
        {
            title: 'Hunza Valley Cherry Blossom Festival',
            date: '18/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Skardu vs Hunza: Which Tour Fits You?',
            date: '16/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        },
        {
            title: 'Spring Season in Hunza: What to Expect',
            date: '12/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        }
    ],
    "hunza-nagar-naltar-tour": [
        {
            title: 'Extended Tours: 8-Day Adventure Itineraries',
            date: '19/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Exploring Nagar & Naltar: Hidden Gems',
            date: '17/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        },
        {
            title: 'Multi-Destination Tours: Hunza, Nagar & More',
            date: '15/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        }
    ],
    "fairy-meadows-hunza-tour": [
        {
            title: 'Trekking to Fairy Meadows: Complete Guide',
            date: '18/4/2026',
            image: '/assets/img/blog/recent-post-1-1.jpg'
        },
        {
            title: 'Mountain Adventure: Preparing for Fairy Meadows',
            date: '16/4/2026',
            image: '/assets/img/blog/recent-post-1-2.jpg'
        },
        {
            title: 'Alpine Meadows & Mountain Views in Hunza',
            date: '14/4/2026',
            image: '/assets/img/blog/recent-post-1-3.jpg'
        }
    ]
};
